export default __webpack_public_path__ + "static/media/completed.ac4cb1f6.png";